import { c as _c } from "react/compiler-runtime";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { OverridableStringUnion } from '@mui/types';
export const Right = t0 => {
  const $ = _c(6);
  const {
    onClick,
    color,
    fontSize: t1
  } = t0;
  const fontSize = t1 === undefined ? "large" : t1;
  let t2;
  if ($[0] !== color) {
    t2 = {
      color
    };
    $[0] = color;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== fontSize || $[3] !== onClick || $[4] !== t2) {
    t3 = <ChevronRightIcon aria-label="Inspect" onClick={onClick} fontSize={fontSize} sx={t2} />;
    $[2] = fontSize;
    $[3] = onClick;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};